export const bucketUrl =
  window.location.hostname === 'cybershtab.ru'
    ? 'https://media.cybershtab.ru/cybershtab-front/'
    : 'http://10.244.0.242:9000/cybershtab-local-bucket/';

export const sseURL = window.location.hostname === 'cybershtab.ru'
  ? 'https://cybershtab.ru/api/v1/users/stream/'
  : 'http://dev.cybershtab.infosec.local/api/v1/users/stream/';